/**
 * Copy for a failure AFTER the camera started. These used to all read "Camera
 * access is required" — wrong whenever the camera was running fine, which is
 * every one of them (a refused camera has its own `denied` screen).
 */
export function livenessErrorKey(error: string): string {
  if (error === 'liveness_challenge_failed') return 'flow.liveness.error.challenge';
  if (error === 'model_load_failed' || error === 'liveness_session_unavailable') {
    return 'flow.liveness.error.start';
  }
  return 'flow.liveness.error.submit';
}
